import * as Select from '@radix-ui/react-select';
import { Trans, useTranslation } from 'react-i18next';

import { Icon } from '~/chords/Icon';
import { DROPDOWN_CLEAR_SENTINEL_VALUE } from '~/chords/Select/components/DropdownTreeSingleSelect/constants';
import { DROPDOWN_OPTION_CLEAR_CLASS } from '~/chords/Select/components/DropdownTreeSingleSelect/styles';
import type { RadixUiProps } from '~/chords/Select/components/DropdownTreeSingleSelect/types';

export function DropdownItemClear({ radix = {} }: RadixUiProps) {
  const { t } = useTranslation('common');

  return (
    <div className="border-b border-emphasis-subtle">
      <Select.Group {...radix.selectGroup}>
        <Select.Item
          value={DROPDOWN_CLEAR_SENTINEL_VALUE}
          className={DROPDOWN_OPTION_CLEAR_CLASS}
          data-clear-select-item
        >
          <Select.ItemText>
            <Trans
              i18nKey="dropdownTree.clearSelectionWithIcon"
              t={t}
              components={{
                Icon: (
                  <span className="mr-sm">
                    <Icon type="xmark" size="sm" aria-hidden />
                  </span>
                ),
              }}
            />
          </Select.ItemText>
        </Select.Item>
      </Select.Group>
    </div>
  );
}

DropdownItemClear.displayName = 'DropdownItemClear';
